export default __webpack_public_path__ + "static/media/ICM.94e4e2ac.png";